import React from 'react'
import CustomerLoginComponent from 'components/Panel/Customer/Login'
const CustomerLoginContainer = () => {
  return (
    <CustomerLoginComponent/>
  )
}

export default CustomerLoginContainer